export default __webpack_public_path__ + "static/media/outcess21.aace9515.jpeg";